import { NO_DATA_COLOR, type ChoroplethScale, type MetricDef } from '@/constants/sgis-metrics';

interface StatisticsLegendProps {
  scale: ChoroplethScale | null;
  metric: Pick<MetricDef, 'label' | 'unit' | 'format'>;
  loading?: boolean;
}

/** 단계구분도 색상 범례 (지표명 + 버킷별 값 구간 + 자료없음) */
export function StatisticsLegend({ scale, metric, loading }: StatisticsLegendProps) {
  const fmt = (v: number) => `${metric.format(v)}`;

  const rangeLabel = (i: number): string => {
    if (!scale) return '';
    const { colors, thresholds } = scale;
    if (colors.length === 1) return `${fmt(scale.min)} ~ ${fmt(scale.max)}`;
    if (i === 0) return `< ${fmt(thresholds[0])}`;
    if (i === colors.length - 1) return `≥ ${fmt(thresholds[i - 1])}`;
    return `${fmt(thresholds[i - 1])} ~ ${fmt(thresholds[i])}`;
  };

  return (
    <div className="absolute left-3 top-16 md:top-auto md:bottom-8 z-[1000] bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-gray-200 p-3 text-xs">
      <div className="font-semibold text-gray-700 mb-1.5">
        {metric.label} <span className="font-normal text-gray-400">({metric.unit})</span>
      </div>

      {loading ? (
        <div className="text-gray-400 py-1">불러오는 중…</div>
      ) : scale ? (
        <div className="space-y-0.5">
          {scale.colors.map((color, i) => (
            <div key={color + i} className="flex items-center gap-1.5">
              <span
                className="inline-block w-4 h-3 rounded-sm border border-gray-300"
                style={{ backgroundColor: color }}
              />
              <span className="text-gray-600 tabular-nums">{rangeLabel(i)}</span>
            </div>
          ))}
          <div className="flex items-center gap-1.5 pt-0.5">
            <span
              className="inline-block w-4 h-3 rounded-sm border border-gray-300"
              style={{ backgroundColor: NO_DATA_COLOR }}
            />
            <span className="text-gray-500">자료 없음</span>
          </div>
        </div>
      ) : (
        <div className="text-gray-400 py-1">표시할 데이터가 없습니다</div>
      )}
    </div>
  );
}
